import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';
import { getHasDirectSalesCampaignLevelChanged } from './getHasDirectSalesCampaignLevelChanged';
import { getIsNewDeal } from './getIsNewDeal';

export const getHasDirectSalesCampaignNameChanged = createSelector(
  getIsNewDeal,
  (state: Store) => state.dealManagement.backupFormData.commonDeal.dealName,
  (state: Store) => state.dealManagement.commonDeal.dealName,
  (isNewDeal, backupDealName, currentDealName) => {
    if (isNewDeal) return false;
    return backupDealName !== currentDealName;
  },
);

export const getHasDirectSalesCampaignInfoChanged = createSelector(
  getHasDirectSalesCampaignLevelChanged,
  getHasDirectSalesCampaignNameChanged,
  (hasCampaignLevelChanged, hasCampaignNameChanged) => hasCampaignLevelChanged || hasCampaignNameChanged,
);
